export const BRAND = { gold: "#E0A526", navy: "#1B2A41" };

export const BrandLogo = ({ className = "h-8", testId = "brand-logo" }) => (
  <img src="/inticheck-logo.png" alt="IntiCheck" className={`${className} w-auto object-contain`} data-testid={testId} />
);

export const BrandIcon = ({ className = "h-4 w-4", testId = "brand-icon" }) => (
  <img src="/inticheck-icon.png" alt="IntiCheck" className={`${className} object-contain`} data-testid={testId} />
);
